import { Typography } from "@mui/material";
import React, { useMemo } from "react";

const InfoItemValue = ({
  children,
  fontSize,
  color = "#0f172a",
  sx,
  variant = "body2",
  ellipsis = true,
  fontWeight = 600,
  maxLines = 1,
}) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      color,
      fontWeight,
      wordBreak: ellipsis ? undefined : "break-word",
      ...(ellipsis && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        ...(maxLines === 1
          ? { whiteSpace: "nowrap" }
          : {
              display: "-webkit-box",
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: "vertical",
              whiteSpace: "normal",
            }),
      }),
      ...sx,
    };
  }, [sx, fontSize, color, ellipsis, fontWeight, maxLines]);

  return (
    <Typography variant={variant} sx={styles}>
      {children}
    </Typography>
  );
};

export default InfoItemValue;
